<template>
    <div>
        <b-modal
            :visible="value"
            size="lg"
            no-close-on-backdrop
            no-close-on-esc
            @cancel="cancel"
            @close="cancel"
            @hidden="hidden"
        >
            <template #modal-title>
                 Blueprint Tokens
            </template>

            <div id="token-list">

                <div class="token-container m-3">
                    <div class="token-name mb-3">Week Title</div>
                    <div class="blueprint-token-description pl-3">
                        Only one week title should appear on each blueprint. The title should be proceeded with this token 
                         <span class="blueprint-token">*wkt*</span> and followed by this one <span class="blueprint-token">*ewkt*</span>.
                    </div>
                    <div class="token-example pl-4">
                        <div>Ex.</div>
                        <div class="pl-1 blueprint-token">*wkt*</div>
                        <div class="pl-3">The United States in the Early 1800s</div>
                        <div class="pl-1 blueprint-token">*ewkt*</div>
                    </div>
                </div>

                <div class="token-container m-3">
                    <div class="token-name mb-3">Week Number</div>
                    <div class="blueprint-token-description pl-3">
                        Only one week number should appear on each blueprint. The number itself should be proceeded with this token 
                         <span class="blueprint-token">*wk#*</span> and followed by this one <span class="blueprint-token">*ewk#*</span>.
                    </div>
                    <div class="token-example pl-4">
                        <div>Ex.</div>
                        <div class="pl-1 blueprint-token">*wk#* </div>
                        <div class="pl-3">1</div>
                        <div class="pl-1 blueprint-token">*ewk#*</div>
                    </div>
                </div>

                <div class="token-container m-3">
                    <div class="token-name mb-3">Article Contents</div>
                    <div class="blueprint-token-description pl-3">
                        Each article including all of it's contents (article body, article vocabulary, article questions etc.) 
                        should be preceeded by this token <span class="blueprint-token">*ac*</span> and followed by this one 
                        <span class="blueprint-token">*eac*</span>.
                    </div>
                    <div class="token-example pl-4">
                        <div>Ex.</div>
                        <div class="pl-1 blueprint-token">*ac* </div>
                        <div class="pl-3">*a* article body..... *ea*</div>
                        <div class="pl-3">*aq* article questions.... *eaq*</div>
                        <div class="pl-3">*av* article vocabulary..... *eav*</div>
                        <div class="pl-1 blueprint-token">*eac*</div>
                    </div>
                </div>

                <div class="token-container m-3">
                    <div class="token-name mb-3">Article Body</div>
                    <div class="blueprint-token-description pl-3">
                        Each article's body should be preceeded by this token <span class="blueprint-token">*a*</span> and followed by this one 
                        <span class="blueprint-token">*ea*</span>.
                    </div>
                    <div class="token-example pl-4">
                        <div>Ex.</div>
                        <div class="pl-1 blueprint-token">*a* </div>
                        <div class="pl-3">article text.....</div>
                        <div class="pl-1 blueprint-token">*ea*</div>
                    </div>
                </div>

                <div class="token-container m-3">
                    <div class="token-name mb-3">Article Title</div>
                    <div class="blueprint-token-description pl-3">
                        Each article's title should be preceeded by this token <span class="blueprint-token">*at*</span> and followed by this one 
                        <span class="blueprint-token">*eat*</span>.
                    </div>
                    <div class="token-example pl-4">
                        <div>Ex.</div>
                        <div class="pl-1 blueprint-token">*at* </div>
                        <div class="pl-3">article title.....</div>
                        <div class="pl-1 blueprint-token">*eat*</div>
                    </div>
                </div>

                <div class="token-container m-3">
                    <div class="token-name mb-3">Article Page</div>
                    <div class="blueprint-token-description pl-3">
                        Each article's Page should be preceeded by this token <span class="blueprint-token">*ap*</span> and followed by this one 
                        <span class="blueprint-token">*eap*</span>.
                    </div>
                    <div class="token-example pl-4">
                        <div>Ex.</div>
                        <div class="pl-1 blueprint-token">*ap* </div>
                        <div class="pl-3">Page 1</div>
                        <div class="pl-1 blueprint-token">*eap*</div>
                    </div>
                </div>

                <div class="token-container m-3">
                    <div class="token-name mb-3">Article Number</div>
                    <div class="blueprint-token-description pl-3">
                        Each article's Number should be preceeded by this token <span class="blueprint-token">*a#*</span> and followed by this one 
                        <span class="blueprint-token">*ea#*</span>.
                    </div>
                    <div class="token-example pl-4">
                        <div>Ex.</div>
                        <div class="pl-1 blueprint-token">*a#* </div>
                        <div class="pl-3"> 1 </div>
                        <div class="pl-1 blueprint-token">*ea#*</div>
                    </div>
                </div>

                <div class="token-container m-3">
                    <div class="token-name mb-3">Article Citations (Optional)</div>
                    <div class="blueprint-token-description pl-3">
                        Include all citations in one block per article, between
                        <span class="blueprint-token">*acit*</span> and <span class="blueprint-token">*eacit*</span>,
                        inside the article's <span class="blueprint-token">*ac*</span> and
                        <span class="blueprint-token">*eac*</span> container, outside its body block.
                        Paragraphs, bold, italic, and underline formatting are preserved.
                        Omit this block or leave it empty when there are no citations.
                    </div>
                    <div class="token-example pl-4">
                        <div>Ex.</div>
                        <div class="pl-1 blueprint-token">*acit*</div>
                        <div class="pl-3">Smith, Jane. <em>History of the West.</em> Example Press, 2024.</div>
                        <div class="pl-3">National Archives. “Westward Expansion.”</div>
                        <div class="pl-1 blueprint-token">*eacit*</div>
                    </div>
                </div>

                <div class="token-container m-3">
                    <div class="token-name mb-3">Article Vocabulary</div>
                    <div class="blueprint-token-description pl-3">
                        Each article's Vocabulary should be preceeded by this token <span class="blueprint-token">*av*</span> and followed by this one 
                        <span class="blueprint-token">*eav*</span>. Each vocabulary term and definision should be seperated by a colon.
                    </div>
                    <div class="token-example pl-4">
                        <div>Ex.</div>
                        <div class="pl-1 blueprint-token">*av* </div>
                        <div class="pl-3"> regions: areas that are defined by cert...  </div>
                        <div class="pl-3"> Cartographer: a person wh.... </div>
                        <div class="pl-1 blueprint-token">*eav*</div>
                    </div>
                </div>

                <div class="token-container m-3">
                    <div class="token-name mb-3">Article Questions</div>
                    <div class="blueprint-token-description pl-3">
                        Each article's questions should be preceeded by this token <span class="blueprint-token">*aq*</span> and followed by this one 
                        <span class="blueprint-token">*eaq*</span>. 
                        Questions should be in an ordered list, the question line should be followed by a double 
                        <span class="blueprint-token">**</span>,  
                        while the correct answer should be followed by an 
                        <span class="blueprint-token">*</span>.
                    </div>
                    <div class="token-example pl-4">
                        <div>Ex.</div>
                        <div class="pl-1 blueprint-token">*aq* </div>
                        <div class="pl-2">1. What is someone who examines and maps land called? <span class="blueprint-token">**</span></div>
                        <div class="pl-5">a. a surveyor <span class="blueprint-token">*</span></div>
                        <div class="pl-5">b. an integrator </div>
                        <div class="pl-2">1. What are areas that are defined by certain characteristics? <span class="blueprint-token">**</span></div>
                        <div class="pl-5">a. groups</div>
                        <div class="pl-5">b. regions <span class="blueprint-token">*</span></div>
                        <div class="pl-1 blueprint-token">*eaq*</div>
                    </div>
                </div>
            </div>

            <template #modal-footer>
                <b-button
                    variant="light"
                    @click="cancel"
                >
                    Close
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
    .token-name{
        font-weight: 800;
        border-bottom: 2px solid black;
    }
    .blueprint-token{
        color: red;
    }
    .token-example{
        // font-size: smaller;
        font-weight: 700;
    }
</style>

<script>
export default {
    data: () => ({
       
    }),
    props: [
       'value',  
    ],
    components: {
        
    },
    methods: {
        cancel (event) {
            event.preventDefault()

            this.hide()
        },
        hide () {
            this.$emit('hide')
        },
        hidden () {
            this.$emit('hide')
        }
    }
}
</script>
